import * as configUtils from "util/config";

const statusTagColorBatch = (state) => {
    const improvements = configUtils.getBoolean("frontend.show.MultipleTransfers.improvements.functionalities", false);
    switch (state) {
        case "PENDING":
        case "PENDING_VALIDATION":
        case "PENDING_SEND":
            return "#ffe5b6";
        case "RECEIVED":
            return "#e6e6e6";
        case "FINISHED_ERROR":
            return improvements ? "#a4d4ad" : "#84efd0";
        case "FINISHED_SUCCESS":
        case "SUCCESS":
            return "#84efd0";
        case "CANCELLED":
        case "FAILED":
        case "ERROR":
            return "#feb0af";
        default:
            return "#e6e6e6";
    }
};

export const getMultipleTransfersI18nKey = (baseKey) => {
    const improvements = configUtils.getBoolean("frontend.show.MultipleTransfers.improvements.functionalities", false);
    return improvements ? baseKey : `${baseKey}.old`;
};

export default statusTagColorBatch;
